import { useEffect, useState } from 'react';
import { getAuthClient } from '@talk2nick/shared';

/**
 * 어드민 커스텀 클레임 확인 (PLAN 5-13장).
 *
 * 클레임은 ID 토큰에 들어 있으므로 캐시를 새로고침해야 바뀐다.
 * Rules도 `request.auth.token.admin == true`로 같은 값을 다시 확인하므로,
 * 이 훅은 **UI 표시용**일 뿐 권한의 근거가 아니다.
 */
export function useAdminClaim(uid: string | null): boolean {
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    if (!uid) {
      setAdmin(false);
      return;
    }
    let cancelled = false;
    const user = getAuthClient().currentUser;
    if (!user) {
      setAdmin(false);
      return;
    }
    void user
      .getIdTokenResult(true)
      .then((result) => {
        if (!cancelled) setAdmin(result.claims.admin === true);
      })
      .catch((error: unknown) => {
        console.error('[talk2nIcK] 어드민 클레임 확인 실패:', error);
        if (!cancelled) setAdmin(false);
      });
    return () => {
      cancelled = true;
    };
  }, [uid]);

  return admin;
}
